



















































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import KriteriaIcuSvc from "@/services/KriteriaIcuService";

const todayDate = () => localISODate();

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class KriteriaIcuMasukSection extends Vue {
  @Prop() data!: any;
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  form: any = this.defaultForm();
  saving = false;

  signDialog = false;
  signPassword = "";
  showPassword = false;
  signError = "";
  signing = false;

  //  Blanko RSPS revisi 30 Juli 2026 — 8 baris blanko + Post Operasi dgn
  //  Penyakit Pemberat + Lainnya. Urutan harus sama dengan blade PDF.
  readonly kriteriaFields = [
    "km_gagal_nafas",
    "km_syok",
    "km_sepsis",
    "km_pasca_operasi",
    "km_post_op_pemberat",
    "km_pasca_rjp",
    "km_kardio_respirasi",
    "km_kondisi_kritis_lain",
    "km_transportable",
    "km_lainnya",
  ];

  get isMasukLocked() {
    return this.data?.is_masuk_locked || false;
  }

  get validationError() {
    if (!this.kriteriaFields.some(f => this.form[f] === true)) {
      return "Minimal 1 kriteria masuk harus dicentang";
    }
    if (this.form.km_post_op_pemberat && !String(this.form.km_post_op_pemberat_text || "").trim()) {
      return "Penyakit pemberat harus diisi";
    }
    if (this.form.km_lainnya && !String(this.form.km_lainnya_text || "").trim()) {
      return "Keterangan lainnya harus diisi";
    }
    return "";
  }

  defaultForm() {
    return {
      km_gagal_nafas: false,
      km_syok: false,
      km_sepsis: false,
      km_pasca_operasi: false,
      km_post_op_pemberat: false,
      km_post_op_pemberat_text: "",
      km_pasca_rjp: false,
      km_kardio_respirasi: false,
      km_kondisi_kritis_lain: false,
      km_transportable: false,
      km_lainnya: false,
      km_lainnya_text: "",
      km_dokter_nama: userModule.user?.nama || "",
      km_tanggal: todayDate(),
    };
  }

  @Watch("data", { immediate: true })
  onDataChange() {
    if (this.data) this.populateForm();
  }

  //  Kosongkan keterangan saat centangnya dilepas agar tidak tersimpan yatim
  @Watch("form.km_post_op_pemberat")
  onPostOpPemberatChange(val: boolean) {
    if (!val) this.form.km_post_op_pemberat_text = "";
  }

  @Watch("form.km_lainnya")
  onLainnyaChange(val: boolean) {
    if (!val) this.form.km_lainnya_text = "";
  }

  populateForm() {
    const d = this.data;
    Object.keys(this.form).forEach(key => {
      if (d[key] !== undefined && d[key] !== null) {
        this.form[key] = d[key];
      }
    });
  }

  async persist(): Promise<any> {
    const createPayload = { ...this.form, register_id: this.register, pasien_rm: this.rm };
    let resp;
    if (this.data?.id) {
      try {
        resp = await KriteriaIcuSvc.update(this.data.id, { ...this.data, ...this.form });
      } catch (err) {
        if (err?.response?.status === 404) {
          resp = await KriteriaIcuSvc.create(createPayload);
        } else {
          throw err;
        }
      }
    } else {
      resp = await KriteriaIcuSvc.create(createPayload);
    }
    return resp;
  }

  async save() {
    if (this.validationError) {
      appModule.NoticeDelay(this.validationError);
      return;
    }
    this.saving = true;
    try {
      const resp = await this.persist();
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menyimpan kriteria masuk ICU");
        this.$emit("saved", resp.data.data);
      }
    } catch (e) {
      // handled by service
    }
    this.saving = false;
  }

  openSign() {
    if (this.validationError) {
      appModule.NoticeDelay(this.validationError);
      return;
    }
    this.signPassword = "";
    this.signError = "";
    this.signDialog = true;
  }

  async doSign() {
    if (!this.signPassword) {
      this.signError = "Password harus diisi";
      return;
    }
    this.signing = true;
    this.signError = "";
    try {
      const resp = await this.persist();
      const id = resp?.data?.data?.id || this.data?.id;
      if (!id) {
        this.signError = "Data harus disimpan terlebih dahulu";
        this.signing = false;
        return;
      }
      const signResp = await KriteriaIcuSvc.signMasuk(id, { password: this.signPassword });
      if (signResp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menandatangani Kriteria Masuk ICU");
        this.signDialog = false;
        this.$emit("saved", resp.data.data);
      }
    } catch (e) {
      this.signError = "Gagal menandatangani. Periksa password Anda.";
    }
    this.signing = false;
  }
}
